import { Component, Input } from '@angular/core';
import { UnitsService } from '../../../../services/config/units.service';

@Component({
  selector: 'app-question-quantitative',
  templateUrl: './question-quantitative.component.html',
  styleUrls: ['./question-quantitative.component.scss'],
  standalone: false
})
export class QuestionQuantitativeComponent {
  @Input() question: any;
  @Input() editable: boolean = false;
  @Input() isResponse: boolean = false;

  constructor(public unitsService: UnitsService) {}

  get getCustoms() {
    return this.question.customs;
  }
}
